<template>
  <div>
    <div
      class="container"
      :style="{minHeight:minHeight + 'px'}"
    >

      <Head msg="Welcome to Your Vue.js App" />
      <img style="width:100%;height:300px;" src="./../../assets/image/back/qiyeziping_back.jpg" alt="">
      <div class="content">
        <div class="title">自评打分</div>
        <div class="tabletitle">创新投入</div>
        <!-- 所在行业 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.tradeId"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.column2"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in trades"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="column3"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>

        <!-- 所在领域 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.domainId"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.column2"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in domains"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="column3"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>
        <!-- 创新经费 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.innovateFee"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字,最多为两位小数"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>

        <!-- 创新人才 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.innovatePresion"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>

        <div class="tabletitle">创新条件</div>
        <!-- 技术积累 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.technology"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>
        <!-- 创新平台 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.innovativePlatform"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>
        <div class="tabletitle">创新绩效</div>
        <!-- 技术产出 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.technologyOutput"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>

        <!-- 创新效益 -->
        <el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.innovationBenefit"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字,最多为两位小数"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>
<div class="tabletitle">加分项</div>
<!-- 获国家自然科学、技术发明、 科技进步奖项目数 -->
<el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.nationalPrize"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>
<!-- 获省部级科技进步奖项目数 -->
<el-table
          border
          :show-header="false"
          style="width: 100%"
          :header-cell-style="getRowClass"
          :data="SelfEvaluateForm.provincialPrize"
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="column0"
            label=""
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column1"
            label=""
            width="600"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="column2"
            label=""
            align="center"
            width="240"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.column2" placeholder="请输入数字"><template slot="append">{{scope.row.column3}}</template></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="column4"
            label=""
            align="center"
          >
          </el-table-column>
        </el-table>



        <div class="enterbtn">
          <el-button
            type="success"
            style="padding:15px"
            @click="SelfEvaluateSubmit"
          >确认并提交</el-button>
        </div>
      </div>
    </div>
    <Footer msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";
import { selfEvaluate, selfTrades,selfDomains } from "@/api/evaluate";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      minHeight: 0,
      trades: "", //evaluate/self/trades 接口获取
      domains:"",
      scoreColor: "",
      decimalTest:/^(\-)?(\d{1,9})(\.\d{1,2})?$/,
      numTest:/^\d{1,9}$/,
      SelfEvaluateForm: {
        tradeId: [
          {
            column1: "所在行业",
            column2: ""
          }
        ],
        domainId: [
          {
            column1: "所在领域",
            column2: ""
          }
        ],
        innovateFee: [
          {
            column0: "创新经费",
            column1: "主营业务收入",
            column2: "",
            column3: "万元"
          },
          {
            column0: "创新经费",
            column1: "研发经费支出占主营业务收入的比重",
            column2: "",
            column3: "%",
            column4: ""
          },
          {
            column0: "创新经费",
            column1: "研发人员人均研发经费支出",
            column2: "",
            column3: "万元",
            column4: ""
          }
        ],
        innovatePresion: [
          {
            column0: "创新人才",
            column1: "研发人员占企业职工总数的比重",
            column2: "",
            column3: "%",
            column4: ""
          },
          {
            column0: "创新人才",
            column1: "技术中心拥有的高级专家和博士人数",
            column2: "",
            column3: "人",
            column4: ""
          },
          {
            column0: "创新人才",
            column1: "来技术中心从事研发工作的外部专家人月数",
            column2: "",
            column3: "人月",
            column4: ""
          }
        ],
        technology: [
          {
            column0: "技术积累",
            column1: "企业拥有的全部有效知识产权数",
            column2: "",
            column3: "件",
            column4: ""
          },
          {
            column0: "技术积累",
            column1: "其中：全部有效发明专利数",
            column2: "",
            column3: "件",
            column4: ""
          },
          {
            column0: "技术积累",
            column1: "企业全部研发项目数",
            column2: "",
            column3: "项",
            column4: ""
          },
          {
            column0: "技术积累",
            column1: "基础研究和应用研究项目数占全部研发项目数的比重",
            column2: "",
            column3: "%",
            column4: ""
          }
        ],
        innovativePlatform: [
          {
            column0: "创新平台",
            column1: "企业技术开发仪器设备原值",
            column2: "",
            column3: "万元",
            column4: ""
          },
          {
            column0: "创新平台",
            column1: "国家级研发平台数",
            column2: "",
            column3: "个",
            column4: ""
          },
          {
            column0: "创新平台",
            column1: "省级研发平台数",
            column2: "",
            column3: "个",
            column4: ""
          },
          {
            column0: "创新平台",
            column1: "通过国家（国际组织）认证的实验室和检测机构数",
            column2: "",
            column3: "个",
            column4: ""
          }
        ],
        technologyOutput: [
          {
            column0: "创新产出",
            column1: "当年被受理的专利申请数",
            column2: "",
            column3: "项",
            column4: ""
          },
          {
            column0: "创新产出",
            column1: "当年被受理的发明专利申请数",
            column2: "",
            column3: "项",
            column4: ""
          },
          {
            column0: "创新产出",
            column1:
              "最近三年主持和参加制定的国际、国家和行业标准数（建筑业包含近四年国家级工法）",
            column2: "",
            column3: "项",
            column4: ""
          }
        ],
        innovationBenefit: [
          {
            column0: "创新效益",
            column1: "利润率",
            column2: "",
            column3: "%",
            column4: ""
          },
          {
            column0: "创新效益",
            column1: "新产品销售收入占主营业务收入的比重",
            column2: "",
            column3: "%",
            column4: ""
          },
          {
            column0: "创新效益",
            column1: "新产品销售利润占利润总额的比重",
            column2: "",
            column3: "%",
            column4: ""
          }
        ],
        nationalPrize: [
          {
            column0: "获国家自然科学、技术发明、 科技进步奖项目数、中国专利奖项目数（建筑企业包括：中国建设工程鲁班奖、国家优质工程奖，中国土木工程詹天佑奖）",
            column1: "",
            column2: "",
            column3: "项",
            column4: ""
          }
        ],
        provincialPrize: [
          {
            column0: "获省部级科技进步奖项目数；获工业企业知识产权运用试点企业情况；获北京市人民政府质量管理奖；获全国质量标杆；获国家标准化试点项目情况",
            column1: "",
            column2: "",
            column3: "项",
            column4: ""
          }
        ]
      }
    };
  },
  methods: {
    SelfEvaluateSubmit() {
      let that = this;
      let validData =  that.SelfEvaluateForm;
      //数据校验
      //所在行业
      if(that.checkNotBlank(validData.tradeId[0].column2)){
        this.$message.error(validData.tradeId[0].column1+"不能为空")
        return
      }
      //所在领域
      if(that.checkNotBlank(validData.domainId[0].column2)){
        this.$message.error(validData.domainId[0].column1+"不能为空")
        return
      }
      //创新经费
      if(that.checkNotBlank(validData.innovateFee[0].column2)){
        this.$message.error(validData.innovateFee[0].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovateFee[0].column2)){
          this.$message.error(validData.innovateFee[0].column1+"应为数字,最多为两位小数")
          return
        }
      }
      if(that.checkNotBlank(validData.innovateFee[1].column2)){
        this.$message.error(validData.innovateFee[1].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovateFee[1].column2)){
          this.$message.error(validData.innovateFee[1].column1+"应为数字,最多为两位小数")
          return
        }
      }
      if(that.checkNotBlank(validData.innovateFee[2].column2)){
        this.$message.error(validData.innovateFee[2].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovateFee[2].column2)){
          this.$message.error(validData.innovateFee[2].column1+"应为数字,最多为两位小数")
          return
        }
      }
      //创新人才
      if(that.checkNotBlank(validData.innovatePresion[0].column2)){
        this.$message.error(validData.innovatePresion[0].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovatePresion[0].column2)){
          this.$message.error(validData.innovatePresion[0].column1+"应为数字,最多为两位小数")
          return
        }
      }
      if(that.checkNotBlank(validData.innovatePresion[1].column2)){
        this.$message.error(validData.innovatePresion[1].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.innovatePresion[1].column2)){
          this.$message.error(validData.innovatePresion[1].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.innovatePresion[2].column2)){
        this.$message.error(validData.innovatePresion[2].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovatePresion[2].column2)){
          this.$message.error(validData.innovatePresion[2].column1+"应为数字,最多为两位小数")
          return
        }
      }
      //技术积累
      if(that.checkNotBlank(validData.technology[0].column2)){
        this.$message.error(validData.technology[0].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.technology[0].column2)){
          this.$message.error(validData.technology[0].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.technology[1].column2)){
        this.$message.error(validData.technology[1].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.technology[1].column2)){
          this.$message.error(validData.technology[1].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.technology[2].column2)){
        this.$message.error(validData.technology[2].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.technology[2].column2)){
          this.$message.error(validData.technology[2].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.technology[3].column2)){
        this.$message.error(validData.technology[3].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.technology[3].column2)){
          this.$message.error(validData.technology[3].column1+"应为数字,最多为两位小数")
          return
        }
      }
      //创新平台
      if(that.checkNotBlank(validData.innovativePlatform[0].column2)){
        this.$message.error(validData.innovativePlatform[0].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovativePlatform[0].column2)){
          this.$message.error(validData.innovativePlatform[0].column1+"应为数字,最多为两位小数")
          return
        }
      }
      if(that.checkNotBlank(validData.innovativePlatform[1].column2)){
        this.$message.error(validData.innovativePlatform[1].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.innovativePlatform[1].column2)){
          this.$message.error(validData.innovativePlatform[1].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.innovativePlatform[2].column2)){
        this.$message.error(validData.innovativePlatform[2].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.innovativePlatform[2].column2)){
          this.$message.error(validData.innovativePlatform[2].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.innovativePlatform[3].column2)){
        this.$message.error(validData.innovativePlatform[3].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.innovativePlatform[3].column2)){
          this.$message.error(validData.innovativePlatform[3].column1+"应为数字")
          return
        }
      }
      //创新产出
      if(that.checkNotBlank(validData.technologyOutput[0].column2)){
        this.$message.error(validData.technologyOutput[0].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.technologyOutput[0].column2)){
          this.$message.error(validData.technologyOutput[0].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.technologyOutput[1].column2)){
        this.$message.error(validData.technologyOutput[1].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.technologyOutput[1].column2)){
          this.$message.error(validData.technologyOutput[1].column1+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.technologyOutput[2].column2)){
        this.$message.error(validData.technologyOutput[2].column1+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.technologyOutput[2].column2)){
          this.$message.error(validData.technologyOutput[2].column1+"应为数字")
          return
        }
      }
      //创新效益
      if(that.checkNotBlank(validData.innovationBenefit[0].column2)){
        this.$message.error(validData.innovationBenefit[0].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovationBenefit[0].column2)){
          this.$message.error(validData.innovationBenefit[0].column1+"应为数字,最多为两位小数")
          return
        }
      }
      if(that.checkNotBlank(validData.innovationBenefit[1].column2)){
        this.$message.error(validData.innovationBenefit[1].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovationBenefit[1].column2)){
          this.$message.error(validData.innovationBenefit[1].column1+"应为数字,最多为两位小数")
          return
        }
      }
      if(that.checkNotBlank(validData.innovationBenefit[2].column2)){
        this.$message.error(validData.innovationBenefit[2].column1+"不能为空")
        return
      }else{
        if(!that.decimalTest.test(validData.innovationBenefit[2].column2)){
          this.$message.error(validData.innovationBenefit[2].column1+"应为数字,最多为两位小数")
          return
        }
      }

      //加分项
      if(that.checkNotBlank(validData.nationalPrize[0].column2)){
        this.$message.error(validData.nationalPrize[0].column0+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.nationalPrize[0].column2)){
          this.$message.error(validData.nationalPrize[0].column0+"应为数字")
          return
        }
      }
      if(that.checkNotBlank(validData.provincialPrize[0].column2)){
        this.$message.error(validData.provincialPrize[0].column0+"不能为空")
        return
      }else{
        if(!that.numTest.test(validData.provincialPrize[0].column2)){
          this.$message.error(validData.provincialPrize[0].column0+"应为数字")
          return
        }
      }


      const SelfEvaluateForm = {
        //基础自评
        basicId: this.basicId,
        basicSecret: this.basicSecret,
        //所在行业
        tradeId: this.SelfEvaluateForm.tradeId[0].column2,
        //所在领域
        domainId: this.SelfEvaluateForm.domainId[0].column2,
        //创新经费
        income: this.SelfEvaluateForm.innovateFee[0].column2 / 10000,
        fundsSpendIncomeProportion:
          this.SelfEvaluateForm.innovateFee[1].column2 / 100,
        fundsSpend: this.SelfEvaluateForm.innovateFee[2].column2,
        //创新人才
        developerProportion:
          this.SelfEvaluateForm.innovatePresion[0].column2 / 100,
        expertNum: this.SelfEvaluateForm.innovatePresion[1].column2,
        externalExpertNum: this.SelfEvaluateForm.innovatePresion[2].column2,
        //技术积累
        intellectualPropertyNum: this.SelfEvaluateForm.technology[0].column2,
        patentNum: this.SelfEvaluateForm.technology[1].column2,
        projectNum: this.SelfEvaluateForm.technology[2].column2,
        projectProportion: this.SelfEvaluateForm.technology[3].column2 / 100,

        //创新平台
        deviceValue: this.SelfEvaluateForm.innovativePlatform[0].column2,
        countryPlatformNum: this.SelfEvaluateForm.innovativePlatform[1].column2,
        provincePlatformNum: this.SelfEvaluateForm.innovativePlatform[2]
          .column2,
        organizationNum: this.SelfEvaluateForm.innovativePlatform[3].column2,
        //创新产出
        acceptPatentNum: this.SelfEvaluateForm.technologyOutput[0].column2,
        acceptInventPatentNum: this.SelfEvaluateForm.technologyOutput[1]
          .column2,
        standardNum: this.SelfEvaluateForm.technologyOutput[2].column2,
        //创新效益
        contributionRate:
          this.SelfEvaluateForm.innovationBenefit[0].column2 >= 0 ? this.SelfEvaluateForm.innovationBenefit[0].column2 / 100 : 0,
        incomeProportion:
          this.SelfEvaluateForm.innovationBenefit[1].column2 / 100,
        profitProportion:
          this.SelfEvaluateForm.innovationBenefit[2].column2 / 100,
        //国家奖
        bigPrizeNum: this.SelfEvaluateForm.nationalPrize[0].column2,
        //省级奖
        smallPrizeNum: this.SelfEvaluateForm.provincialPrize[0].column2
      };

  //新产品销售利润占利润总额的比重为负值情况处理
  if(this.SelfEvaluateForm.innovationBenefit[2].column2 < 0 ){
    const h = this.$createElement;
    this.$msgbox({
          title: "消息",
          message: h('p', null, [
            h('span', null, '新产品销售利润占利润总额的比重为负值'),
            h('i', { style: 'color: teal' }, '请联系系统管理员！')
          ]),
          confirmButtonText: "确定"
        })
        return false;
  }

      selfEvaluate(SelfEvaluateForm).then(res => {
        //创新经费
        //this.SelfEvaluateForm.innovateFee[0].column2 = res.income,    
        this.SelfEvaluateForm.innovateFee[1].column4 = res.fundsSpendIncomeProportion + "分",
        this.SelfEvaluateForm.innovateFee[2].column4 = res.fundsSpend + "分",
        //创新人才
        this.SelfEvaluateForm.innovatePresion[0].column4 = res.developerProportion + "分",
        this.SelfEvaluateForm.innovatePresion[1].column4 = res.expertNum + "分",
        this.SelfEvaluateForm.innovatePresion[2].column4 = res.externalExpertNum + "分",
        //技术积累
        this.SelfEvaluateForm.technology[0].column4 = res.intellectualPropertyNum + "分",
        this.SelfEvaluateForm.technology[1].column4 = res.patentNum + "分",
        this.SelfEvaluateForm.technology[2].column4 = res.projectNum + "分",
        this.SelfEvaluateForm.technology[3].column4 = res.projectProportion + "分",

        //创新平台
        this.SelfEvaluateForm.innovativePlatform[0].column4 = res.deviceValue,
        this.SelfEvaluateForm.innovativePlatform[1].column4 = res.countryPlatformNum + "分",
        this.SelfEvaluateForm.innovativePlatform[2].column4 = res.provincePlatformNum + "分",
        this.SelfEvaluateForm.innovativePlatform[3].column4 = res.organizationNum + "分",
        //创新产出
        this.SelfEvaluateForm.technologyOutput[0].column4 = res.acceptPatentNum + "分",
        this.SelfEvaluateForm.technologyOutput[1].column4 = res.acceptInventPatentNum + "分",
        this.SelfEvaluateForm.technologyOutput[2].column4 = res.standardNum + "分",
        //创新效益
          this.SelfEvaluateForm.innovationBenefit[0].column4 = res.contributionRate + "分",
          this.SelfEvaluateForm.innovationBenefit[1].column4 = res.incomeProportion + "分",
          this.SelfEvaluateForm.innovationBenefit[2].column4 = res.profitProportion + "分",
        //国家奖
          this.SelfEvaluateForm.nationalPrize[0].column4 = res.prizeNum + "分(奖项合计分)"
        //省级奖
          //this.SelfEvaluateForm.provincialPrize[0].column4 = res.prizeNum + "分"
        if (res < 60) {
          this.scoreColor = "#fd4e27";
        } else {
          this.scoreColor = "teal";
        }
        const h = this.$createElement;
        this.$msgbox({
          title: "消息",
          message: h("p", null, [
            h("span", null, "您本次自评得分为："),
            h(
              "i",
              { style: "color:" + this.scoreColor + ";font-size:20px;" },
              res.result.toFixed(2) + "分"
            )
          ]),
          showCancelButton: false,
          confirmButtonText: "确定"
        });
      });
    },
    checkNotBlank(str){
      if(str.length == 0 && str.split(" ").join("").length==0){
        return true;
      }
      return false;
    },
    SelfEvaluate() {
      this.$router.push({ path: "/SelfEvaluate" });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#EFEFEF;color:#333333";
      } else {
        return "";
      }
    }
  },
  computed: {
    ...mapGetters(["basicId", "basicSecret"])
  },
  mounted() {
    selfTrades().then(res => {
      this.trades = res;
    });
    selfDomains().then(res => {
      this.domains = res;
    });
    this.minHeight = document.documentElement.clientHeight - 200;
    var me = this;
    window.onresize = function() {
      me.minHeight = document.documentElement.clientHeight - 200;
    };
  },
  components: {
    Head,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 1200px;
  height: 2150px;
  margin: 0 auto;
  background-color: #f5f5f5;
}
.title {
  height: 50px;
  margin: 50px 0 0;
  line-height: 50px;
  color: #ffffff;
  background-color: #0088d2;
}
.basicevaluate {
  text-align: left;
  padding: 0 30px;
  h1 {
    padding: 30px 0;
    font-weight: 500;
  }
}
.enterbtn {
  margin-top: 50px;
}
.tabletitle {
  height: 50px;
  line-height: 50px;
  color: #0088d2;
}
</style>
